import { render, staticRenderFns } from "./ScreenVideoPreview.vue?vue&type=template&id=b0dbb602&scoped=true"
import script from "./ScreenVideoPreview.vue?vue&type=script&lang=js"
export * from "./ScreenVideoPreview.vue?vue&type=script&lang=js"
import style0 from "./ScreenVideoPreview.vue?vue&type=style&index=0&id=b0dbb602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dbb602",
  null
  
)

export default component.exports